import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, input } from '@angular/core';
import { TableModule } from 'primeng/table';
import { ToolbarComponent } from '../toolbar/toolbar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { TagModule } from 'primeng/tag';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { CalendarModule } from 'primeng/calendar';
// import { AddPopupComponent } from '../add-popup/add-popup.component';
import { MultiSelectModule } from 'primeng/multiselect';

interface Column {
  field: string;
  header: string;
  customExportHeader?: string;
}

interface ExportColumn {
  title: string;
  dataKey: string;
}

@Component({
  selector: 'app-table',
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    FormsModule,
    ToastModule,
    TagModule,
    DropdownModule,
    ButtonModule,
    InputTextModule,
    RippleModule,
    CheckboxModule,
    RadioButtonModule,
    InputGroupModule,
    InputGroupAddonModule,
    CalendarModule,
    ReactiveFormsModule,
    // AddPopupComponent,
    MultiSelectModule,
  ],
  templateUrl: './table.component.html',
  styleUrl: './table.component.css',
})
export class TableComponent implements OnInit {
  @Input() tableHeader: any[] = [];
  @Input() tableBody: any = [];
  tblHeader = input<any[]>([]);
  fieldInputType = input<any[]>([]);
  newElement: any[] = [];
  // isDisabled = input<boolean>();
  showAddNewButton: boolean = false;
  showAddingForm: boolean = false;
  showToolbar: boolean = false;
  selectedData: String = '';

  isEditable = input<boolean>();

  radioValue1: boolean = false;

  checked: boolean = false;

  category: string | undefined;

  date: Date | undefined;

  exportColumns!: ExportColumn[];

  numberOfItems: number = 0;
  selectedProducts!: any[];
  _selectedColumns: any[] = [];

  metaKey: boolean = true;
  clonedProducts: { [s: string]: any } = [];
  newLineButton: boolean = false;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this._selectedColumns = this.tableHeader;
    console.log(this._selectedColumns);
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.tableHeader.filter((col) => val.includes(col));
  }

  selectColumn(column: any) {
    console.log(column);
  }

  showFormToAddNewValue() {
    this.showAddingForm = true;
  }

  addNewElement($event: any) {
    console.log($event);
    this.tableBody.push($event);
  }

  addnewLine() {
    this.tableBody.unshift(this.tableHeader);
  }

  onRowEditInit(product: any) {
    this.clonedProducts[product.id as string] = { ...product };
    console.log(product);
  }

  onRowEditSave(product: any) {
    delete this.clonedProducts[product.id as string];
  }

  onRowEditCancel(product: any, index: number) {
    this.tableBody[index] = this.clonedProducts[product.id as string];
    delete this.clonedProducts[product.id as string];
  }

  deleteRow(row: any) {
    this.tableBody = this.tableBody.filter((ele: { id: any }) => ele.id !== row.id);
  }

  selectData(data: any) {
    this.showToolbar = true;
    this.selectedData = data;
    console.log(this.selectedData);
  }
}
